var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8486 26.3547C19.8486 31.6528 15.5457 36 10.1325 36C4.58044 36 0 32.1962 0 25.5396C0 14.6717 5.55205 5.70566 13.0473 0L19.4322 6.52075C16.6562 8.28679 12.3533 12.634 11.6593 16.9811C16.795 17.9321 19.8486 22.0075 19.8486 26.3547ZM44 26.3547C44 31.6528 39.6972 36 34.2839 36C28.7319 36 24.1514 32.1962 24.1514 25.5396C24.1514 14.6717 29.7035 5.70566 37.1987 0L43.5836 6.52075C40.8076 8.28679 36.5047 12.634 35.8107 16.9811C40.9464 17.9321 44 22.0075 44 26.3547Z",
    fill: "#F1F3F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuotes);
export default __webpack_public_path__ + "static/media/double_quotes.73edadeb824915b0e3bc12766e87c932.svg";
export { ForwardRef as ReactComponent };